export default "__VITE_ASSET__BKj3vH5I__"